/* eslint-disable */
import axios from "axios";
import "/src/assets/css/animate.css";
import "/src/assets/css/style.css";
import store from '@/store';
import * as XLSX from "xlsx";
import html2pdf from 'html2pdf.js';
import advtable from './rbqm_table.vue';
import historytab from '../../custom_lib/AiCharts/historytab.vue';
import barchart from '../../custom_lib/AiCharts/rbqm_barchart.vue';
import chartdrill from '../../custom_lib/AiCharts/popupfiles/chartdrillPopup.vue';
export default {
  name: "labresultsreport",
  components: {
    advtable,
    barchart,
    historytab,
    chartdrill
  },
  props: {
    fromPage: {
      type: String,
      default: ""
    },
  },

  async mounted() {
  window.addEventListener("studyIdChanged", async (event) => {
    this.historykeys = [];
    this.historydata = {};
    await this.getsites();
    await this.getRactData();
    await this.getRiskNamesForStudy();
    await this.gettabledata();
    await this.riskscoresbysite();
    await this.sitescoresbyriskname();
  });

  await this.getsites();
  await this.getRactData();
  await this.getRiskNamesForStudy();
  await this.gettabledata();
  await this.riskscoresbysite();
  await this.sitescoresbyriskname();
},
  data() {
    return {
      catid: "",
      categoryIds: [],
      riskname: "",
      risknamearray: [],
      sites: "",
      SiteCode: "",
      tabledata: [],
      showVisitPopup: false,
      basetestUrl: process.env.VUE_APP_Service_URL,
      excludecolumns:[
        "riskIndicatorId",
        "riskScoreId",
        "riskScore",
        "siteId",
        "orderNo",
        "isLatest",
        "version",
        "riskLevelLabel",
        "riskLevelColor",
        "dataScope",
        "dataScopeId",
        "riskId",
        "category",
        "subCategory",
        "discussionDetails",
        "coreOrExtendedKRI",
        "generalOrSpecific",
        "levelOfScrutiny",
        "frequency",
        "thresholdBasis",
        "scorecard",
        "weighting",
        "mitigationActions",
        "categoryId",
        "phase",
        "typeOfRisk",
        "objectives",
        "studyId",
        "templateId",
        "CreatedUserId",
        "LastModifiedAt",
        "LastModifiedUserId",
        "LastModifiedUserEmail",
        "AccountId",
        "id"
      ],
      columnsinorder:[
        "siteCode",
        "riskName",
        "riskIndicator",
        "impactPoint",
        "probabilityPoint",
        "detectabilityPoint",
        "score",
        "excecutionType",
        "value",
        "unit",
        "CreatedUserEmail",
        "CreatedAt"
      ]
      ,
  namesobj:{
        siteCode:"Site Code",
        riskName:"Risk Name",
        riskIndicator: "Risk Indicator",
        impactPoint:"Impact Point",
        probabilityPoint:"Probability Point",
        detectabilityPoint:"Detectability Point",
        score:"Score",
        executionType:"Excecution Type",
        value:"Value",
        unit:"Unit",
        CreatedUserEmail:"Created By",
        CreatedAt:"Created Date"
      },
      drillpopup: false,
        data:[],
        datahistory:[],
        historykeys:[],
        historydata:{},
        drilldata:{},
        drilldowndata:[],
      ractlist:[]
    };
  },
  methods: {
    async deleteAfterKeyarrays(selectedKey) {

      let index = this.historykeys.indexOf(selectedKey);

      if (index !== -1) {
          // Slice the array up to the element (including the element)
          this.historykeys = this.historykeys.slice(0, index + 1);
      }
    },
    async gotohistorylevel(history){
      this.deleteAfterKeyvaluearrays(history);
      this.deleteAfterKeyarrays(history);
      this.data = this.historydata[history];
    },
     async deleteAfterKeyvaluearrays(selectedKey) {
      const entries = Object.entries(this.historydata); // Convert the object to an array of entries
      const selectedIndex = entries.findIndex(([key, value]) => key === selectedKey);
    
      // If the key is found, slice the array to keep only the entries up to the selected key
      const newEntries = selectedIndex !== -1 ? entries.slice(0, selectedIndex + 1) : entries;
    
      // Convert the array of entries back into an object
      return Object.fromEntries(newEntries);
    },
    async drilldowncurrentchartforbar(datafromchild){
      console.log("datafromchild",datafromchild);
      const lastkey = this.historykeys[this.historykeys.length - 1];
      if(this.historydata[lastkey].length != datafromchild.sortedData.length){
       this.historykeys.push(datafromchild.filterkeyword);
      this.historydata[datafromchild.filterkeyword] = datafromchild.sortedData;
      this.data = this.historydata[datafromchild.filterkeyword];
      }
    },
    async drillpopupopened(datafromchild) {
      this.drilldata = datafromchild;
      this.drillpopup = true;

    },
    exporttopdf() {
          // Create a temporary container
          const pdfContainer = document.createElement('div');
          const pdfContainer1 = document.createElement('div');
          const pdfContainer2 = document.createElement('div');
          // Add the elements you want to include in the PDF
          const captureArea1 = this.$refs.captureArea1.cloneNode(true);
          const captureArea2 = this.$refs.captureArea2.cloneNode(true);
    
          captureArea2.classList.add('page-break');
          // Append cloned elements to the container
          pdfContainer1.appendChild(captureArea1);
          pdfContainer2.appendChild(captureArea2);
    
          pdfContainer2.style.width = '200%';
    
          pdfContainer.appendChild(pdfContainer1);
          pdfContainer.appendChild(pdfContainer2);
          
          // Optionally style the container for PDF formatting
          pdfContainer.style.display = 'block';
          pdfContainer.style.width = '100%';
          
          // Set the options for html2pdf
          const opt = {
            margin: 0,
            filename: 'RBQM Report.pdf',
            image: { type: 'jpeg', quality: 0.98 },
            html2canvas: { scale: 2 },
            jsPDF: { unit: 'pt', format: 'a4', orientation: 'landscape' }
          };
        
          // Convert the temporary container to PDF
          html2pdf().set(opt).from(pdfContainer).save();
        },
    async exporttoexcell() {
          const worksheet = XLSX.utils.json_to_sheet(this.data);
          const workbook = XLSX.utils.book_new();
          XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
          XLSX.writeFile(workbook, "RBQM Report.xlsx");
        },
    async getRactData() {
  const studyId = store.getters.getStudyIs;
  const dataScopeId = (this.SiteCode.trim() !== '') ? this.SiteCode.trim() : studyId;
  const dataScope = (this.SiteCode.trim() !== '') ? "Site" : "Study";
  const idtoken = store.getters.getIdToken;
  try {
    const res = await axios.get(
      `${this.basetestUrl}/forms/rbqm/getriskitem?StudyId=${studyId}&pageindex=1&pagesize=8000&SortProperty=createdDate&SortOrder=desc&DataScopeId=&DataScope=Site`,
      { headers: { Authorization: `Bearer ${idtoken}` } }
    );
    this.data = Array.isArray(res.data.data.entities) ? res.data.data.entities : [];
    this.historydata['Home'] = this.data;
    this.historykeys.push('Home');
  } catch (err) {
    console.error("Error in getRactData:", err);
    this.data = []; // Reset to prevent stale data
    this.historydata = {};
    this.historykeys = [];
  }
},
    updateFormChartFromAPI(payload) {
      const labels = Array.isArray(payload?.siteCode) ? payload.siteCode : [];
      const values = Array.isArray(payload?.score) ? payload.score : [];

      // For line / vertical bar / scatter
      this.formchart.chartOptions = {
        ...this.formchart.chartOptions,
        xaxis: { ...(this.formchart.chartOptions?.xaxis || {}), categories: labels }
      };
      this.formchartchartOptions = {
        ...this.formchartchartOptions,
        xaxis: { ...(this.formchartchartOptions?.xaxis || {}), categories: labels }
      };


      this.formchart.dataseries = [
        { name: this.$t('navigations.series-1'), data: values }
      ];

      // For horizontal bar (you render with `formbarchart`)
      this.formbarchart = this.formbarchart || { chartOptions: {}, dataseries: [] };
      this.formbarchart.chartOptions = {
        ...this.formchart.chartOptions,
        plotOptions: {
          bar: { borderRadius: 4, horizontal: true }
        },
        xaxis: { categories: labels }
      };
      this.formbarchart.dataseries = [
        { name: this.$t('navigations.series-1'), data: values }
      ];

      // For pie
      this.formchart.piechartOptions = {
        ...(this.formchart.piechartOptions || {}),
        labels
      };
      this.formchart.piedataseries = values;
    },

    // Optional: keep your click handlers simple
    secondchartchange(type) {
      this.formchart.charttype = type;
    },
    async sitescoresbyriskname() {
      const idtoken = store.getters.getIdToken;

      await axios
        .get(
          `${this.basetestUrl}/forms/rbqm/sitescoresbyriskname?riskName=${this.riskname}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.updateFormChartFromAPI(res.data || { siteCode: [], score: [] });
        })
        .catch((err) => {
          console.log(err);
          this.updateFormChartFromAPI({ siteCode: [], score: [] });
        });
    },
    updateSummaryChartFromAPI(payload) {
      const labels = Array.isArray(payload?.riskName) ? payload.riskName : [];
      const values = Array.isArray(payload?.score) ? payload.score : [];

      // For line / vertical bar / scatter
      this.summarychart.chartOptions = {
        ...this.summarychart.chartOptions,
        xaxis: { ...(this.summarychart.chartOptions?.xaxis || {}), categories: labels }
      };
      this.summerychartOptions = {
        ...this.summerychartOptions,
        xaxis: { ...(this.summerychartOptions?.xaxis || {}), categories: labels }
      };
      this.summarychart.dataseries = [
        { name: this.$t('navigations.counts') || 'Counts', data: values }
      ];

      // For horizontal bar (rendered via `summarybarchart` in your template)
      this.summarybarchart = this.summarybarchart || { chartOptions: {}, dataseries: [] };
      this.summarybarchart.chartOptions = {
        ...this.summarychart.chartOptions,
        plotOptions: { bar: { borderRadius: 4, horizontal: true } },
        xaxis: { categories: labels }
      };
      this.summarybarchart.dataseries = [
        { name: this.$t('navigations.counts') || 'Counts', data: values }
      ];

      // For pie mode
      this.summarychart.piechartOptions = {
        ...(this.summarychart.piechartOptions || {}),
        labels
      };
      this.summarychart.piedataseries = values;
    },

    // Simple type switcher to match your template buttons
    fourthchartchange(type) {
      this.summarychart.charttype = type;
    },
    async riskscoresbysite() {
      const idtoken = store.getters.getIdToken;

      await axios
        .get(
          `${this.basetestUrl}/forms/rbqm/riskscoresbysite?siteId=${this.SiteCode}&categoryId=${this.catid}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.updateSummaryChartFromAPI(res.data || { riskName: [], score: [] });
        })
        .catch((err) => {
          console.log(err);
          this.updateSummaryChartFromAPI({ riskName: [], score: [] });
        });
    },
    async gettabledata() {
      const idtoken = store.getters.getIdToken;
      const currentstudy = store.getters.getStudyIs;
      await axios
        .get(
          `${this.basetestUrl}/forms/rbqm/keyriskindicatormetrics?studyId=${currentstudy}`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.tabledata = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getsites() {
      const currentstudy = store.getters.getStudyIs;
      const idtoken = store.getters.getIdToken;

      await axios
        .get(
          `${this.basetestUrl}/management/site/getallsitesbyuser?studyId=${currentstudy}&sortProperty=siteCode&IsDes=false&getAll=false`,
          {
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        )
        .then((res) => {
          this.sites = res.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    async getRiskNamesForStudy() {
      const idtoken = store.getters.getIdToken;
      const studyId = this.studyId || store.getters.getStudyIs;
      if (!studyId) return [];

      try {
        const res = await axios.get(
          `${this.basetestUrl}/forms/rbqm/getriskitem`,
          {
            params: { StudyId: studyId, DataScopeId: studyId, DataScope: "Study" },
            headers: {
              Authorization: "Bearer " + idtoken,
              "Content-Type": "application/json",
            },
          }
        );

        const entities = Array.isArray(res.data.data?.entities) ? res.data.entities : [];

        // Collect unique risk names (case-insensitive, preserve first-seen casing)
        const nameMap = new Map(); // key: lowercased, val: original
        const addName = (n) => {
          if (n == null) return;
          const orig = String(n).trim();
          if (!orig) return;
          const key = orig.toLowerCase();
          if (!nameMap.has(key)) nameMap.set(key, orig);
        };

        for (const item of entities) {
          addName(item?.riskName);
          if (Array.isArray(item?.riskScore)) {
            for (const rs of item.riskScore) addName(rs?.riskName);
          }
        }

        const uniqueNames = [...nameMap.values()].sort((a, b) => a.localeCompare(b));

        // Save to state
        this.risknamearray = uniqueNames;

        // Keep a valid default selection
        if (!this.riskname || !nameMap.has(String(this.riskname).trim().toLowerCase())) {
          this.riskname = uniqueNames[0] || "";
        }

        // (Optional) refresh the forms chart once we have a riskName
        if (this.riskname) await this.sitescoresbyriskname();

        return uniqueNames;
      } catch (err) {
        console.error("Search error:", err);
        this.risknamearray = [];
        return [];
      }

    },

exporttotablepdf() {
  this.$nextTick(() => {
    const pdfContainer = document.createElement('div');

    const tableEl = this.$refs.captureArea3.querySelector('table');
    if (!tableEl) {
      console.warn('No table found inside captureArea3');
      return;
    }

    const clonedTable = tableEl.cloneNode(true);
    const wrapper = document.createElement('div');
    wrapper.appendChild(clonedTable);

    pdfContainer.appendChild(wrapper);

    const opt = {
      margin: 10,
      filename: 'Risk Table.pdf',
      image: { type: 'jpeg', quality: 0.98 },
      html2canvas: { scale: 2, useCORS: true },
      jsPDF: { unit: 'pt', format: 'a4', orientation: 'landscape' },
      pagebreak: {
        mode: ['css', 'legacy', 'avoid-all'],
   
      }
    };

    html2pdf().set(opt).from(pdfContainer).save();
  });
},

exporttotableexcell() {
  this.$nextTick(() => {
    // Find the actual table inside captureArea3 (same as your PDF export)
    const tableEl = this.$refs.captureArea3?.querySelector('table');
    if (!tableEl) {
      console.warn('No table found inside captureArea3');
      return;
    }

    // Clone the table so we can safely manipulate it
    const cloned = tableEl.cloneNode(true);

    // Remove hidden rows/cols so only the "displayed" parts get exported
    // Hidden via CSS: display:none or Bootstrap's d-none or visibility:hidden
    const isHidden = (el) => {
      const cs = getComputedStyle(el);
      return (
        cs.display === 'none' ||
        cs.visibility === 'hidden' ||
        el.classList.contains('d-none')
      );
    };

    // Remove hidden rows
    Array.from(cloned.querySelectorAll('tr')).forEach((tr) => {
      if (isHidden(tr)) tr.remove();
    });

    // Remove hidden columns by checking each cell and removing those th/td
    // (We also need to remove entire column if the header is hidden)
    const headerRow = cloned.querySelector('thead tr') || cloned.querySelector('tr');
    if (headerRow) {
      const headers = Array.from(headerRow.children);
      const hiddenColIndexes = headers
        .map((cell, idx) => (isHidden(cell) ? idx : null))
        .filter((idx) => idx !== null);

      if (hiddenColIndexes.length) {
        Array.from(cloned.querySelectorAll('tr')).forEach((tr) => {
          hiddenColIndexes
            .slice() // copy since we'll mutate
            .reverse() // remove from end to keep indexes stable
            .forEach((colIdx) => {
              const cells = Array.from(tr.children);
              if (cells[colIdx]) tr.removeChild(cells[colIdx]);
            });
        });
      }
    }

    // Optional: remove controls/ellipsis menu cells if present
    Array.from(cloned.querySelectorAll('.plan-side-popup, .cursor-pointer, .fa-ellipsis-v'))
      .forEach((el) => el.remove());

    // Convert the cleaned table to a workbook and save
    const wb = XLSX.utils.table_to_book(cloned, { sheet: 'Risk Table' });
    XLSX.writeFile(wb, 'Risk Table.xlsx');
  });
}









  },
};